import {
  useOperatorHistoryQuery,
  useOperatorQuery,
  useOperatorLogoQuery,
} from '@common/cache';
import { useContext, useEffect, useState } from 'react';
import { AdminPanelDrawerContext } from '@views/pages/Admin/context';

interface IUseOperatorItemProps {
  id: string;
  handleClose: () => void;
}

const historyTabIndex = '2';

export const useOperatorItem = ({ id, handleClose }: IUseOperatorItemProps) => {
  const [historyPage, setHistoryPage] = useState(1);
  const {
    isFormClean,
    handleClear,
    handleCloseTrigger,
    tabIndex,
    handleTriggerChangeTab,
    triggerClose,
  } = useContext(AdminPanelDrawerContext);

  const operator = useOperatorQuery({
    operator_id: id,
  });

  const operatorHistory = useOperatorHistoryQuery({
    operator_id: id,
    page: historyPage,
    limit: 100,
    enabled: historyTabIndex === tabIndex,
  });

  const fetchedLogo = useOperatorLogoQuery({
    operator_id: id,
  });

  useEffect(() => {
    if (isFormClean && triggerClose) {
      handleClose();
      handleClear();
    }
  }, [isFormClean, triggerClose]);

  return {
    fetchedLogo,
    operator,
    tabIndex,
    handleTriggerChangeTab,
    operatorHistory: operatorHistory.data,
    historyPage,
    setHistoryPage,
    handleCloseTrigger,
    historyTabIndex,
  };
};
